import { render } from "./AddGym.vue?vue&type=template&id=b7af6c54&scoped=true"
import script from "./AddGym.vue?vue&type=script&lang=js"
export * from "./AddGym.vue?vue&type=script&lang=js"

import "./AddGym.vue?vue&type=style&index=0&id=b7af6c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7af6c54"]])

export default __exports__